 (function(){
    document.addEventListener('DOMContentLoaded', function() {
      class PopupMessage extends HTMLElement {
        constructor() {
          super();
          this.cookieName = 'makka-popup--closed';
          this.autoCloseTimer = null;
        }

        connectedCallback() {
          if (this.shouldShowPopup()) {
            this.showPopup();
            this.setupEventListeners();
            this.setupAutoClose();
          }
        }

        shouldShowPopup() {
          return !this.getCookie(this.cookieName);
        }

        showPopup() {
          setTimeout(() => {
            this.classList.add('active');
            // debugger;
          }, 100);
        }

        hidePopup() {
          this.classList.remove('active');
          this.setCookie();
          if (this.autoCloseTimer) {
            clearTimeout(this.autoCloseTimer);
          }
        }

        setupEventListeners() {
          const closeButton = this.querySelector('.makka-popup-close');
          
          closeButton.addEventListener('click', () => {
            this.hidePopup();
          });

          this.addEventListener('click', (event) => {
            if (event.target === this) {
              this.hidePopup();
            }
          });

          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.classList.contains('active')) {
              this.hidePopup();
            }
          });
        }

        setupAutoClose() {
          const autoCloseTime = parseInt(this.dataset.autoClose) * 1000;
          // debugger;
          if (autoCloseTime > 0) {
            this.autoCloseTimer = setTimeout(() => {
              this.hidePopup();
            }, autoCloseTime);
          }
        }

        setCookie() {
          const cookieDuration = parseInt(this.dataset.cookieDuration);
          const expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + cookieDuration);document.cookie = `${this.cookieName}=true; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
        }

        getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) {
            return parts.pop().split(';').shift();
          }
          return null;
        }
      }

      customElements.define('popup-message', PopupMessage);
    }, false);
  })();